var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"infoWindowContent",staticClass:"BbGoogleMapInfoWindow"},[(!_vm.loadingInfoWindow && _vm.context)?_c(_vm.infoWindow.component,{tag:"component",attrs:{"info":_vm.context,"selectedMarker":_vm.selectedMarker}}):(_vm.loadingInfoWindow)?_c('div',[_vm._v("cargando...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }